import { get, post } from '../lib/axios';
import { SERVER_URL } from '../config';

class UserService {

    static async getUserPreferences() {
        const url = SERVER_URL + "/v3/user/preferences";
        return await get({ url });
    }

    static async getUserAccountData() {
        const url = SERVER_URL + "/v3/user/";
        return await get({ url });
    }

    static async getPastOrders(payload:any) {
        const url = SERVER_URL + "/v3/user/orders/history";
        return await post({ url, data:payload });
    }

    static async updateUserDietaryPreferences(data:any) {
        const url = SERVER_URL + "/v3/user/allergens";
        return await post({ url, data })
    }

    static async signIn(data:any) {
        const url = SERVER_URL + "/v1/user/signIn";
        return await post({ url, data });
    }

    static async getUpdatedDishPrice(data:any) {
        const url = SERVER_URL + "/v3/user/customization/price";
        return await post({ url, data })
    }

    static async getCoupons(xookId: string, data:any) {
		const url = SERVER_URL + "/v3/user/xook/" + xookId + "/coupons";
		return await post({ url, data });
	}

    static async addCoupon(xookId:string, data:any) {
        const url = SERVER_URL + "/v3/user/xook/" + xookId + "/coupon/apply";
		return await post({ url, data });
    }

    static async removeCoupon(xookId:string, data:any) {
        const url = SERVER_URL + "/v3/user/xook/" + xookId + "/coupon/remove";
		return await post({ url, data });
    }

}

export default UserService;
